// @ts-nocheck
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import toast from "react-hot-toast";

import { useEffect } from "react";
import { WALLET_ADAPTERS } from "@web3auth/base";

enum Web3AuthLoginError {
  PopupBlocked = 5115,
}

const SignInHeaderTelegramBtn = () => {
  const { web3Auth } = useWeb3Auth();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?7";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.Telegram?.Login?.init) {
        window.Telegram.Login.init(
          {
            bot_id: import.meta.env.VITE_TELEGRAM_BOT_ID,
            request_access: true,
            lang: "en",
            userpic: false,
            radius: 20,
            corner_radius: 8,
            element: document.getElementById("telegram-login-widget"),
          },
          async (telegramData) => {
            if (telegramData) {
              const res = await fetch(
                `${import.meta.env.VITE_API_URL_PROD}/api/auth/telegram`,
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(telegramData),
                },
              );

              const { jwt } = await res.json();

              loginWithWeb3Auth(jwt);
            }
          },
        );
      }
    };
  }, []);

  const loginWithWeb3Auth = async (token: string) => {
    try {
      await web3Auth?.connectTo(WALLET_ADAPTERS.AUTH, {
        loginProvider: "jwt",
        extraLoginOptions: {
          id_token: token,
          verifierIdField: "sub",
        },
      });
    } catch (error) {
      if (error.code === Web3AuthLoginError.PopupBlocked) {
        alert(
          "Please enable pop-ups in the browser settings to use Telegram login",
          {
            style: {
              zIndex: "9999999 !important",
            },
          },
        );
      } else {
        throw error;
      }
    }
  };

  return (
    <li className="w3a--col-span-6 w3a-adapter-item" style={{ order: 2 }}>
      <button
        type="button"
        className="t-btn t-btn-secondary w3a--rounded-full size-md w3a--w-full"
        title="Google"
        onClick={() => window.Telegram.Login.open()}
      >
        <img
          src="https://cdn.pixabay.com/photo/2021/12/27/10/50/telegram-icon-6896828_1280.png"
          height="auto"
          width="24"
          alt="login-google-active"
          className="image-icon w3a--object-contain w3a--rounded"
        />
        <img
          src="https://cdn.pixabay.com/photo/2021/12/27/10/50/telegram-icon-6896828_1280.png"
          height="auto"
          width="24"
          alt="login-google-active"
          className="hover-icon w3a--object-contain w3a--rounded"
        />
        <p className="w3a--ml-2">Continue with Telegram</p>
      </button>
    </li>
  );
};

export default SignInHeaderTelegramBtn;
